import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {AbsatzControl, firstNestedSymbolControl, UIArtefakt} from '../../models/uiArtefakt';
import {ISymbol} from '@lv1871/core';
import {UIAusrichtung} from '../../models/uiAusrichtung';
import {ShellConfigService} from '../../services/shell-config.service';
import {TextAusrichtung} from '../../models/textAusrichtung';

@Component({
    selector: 'lv-absatz',
    templateUrl: './absatz.component.html',
    styleUrls: ['./absatz.component.scss'],
    standalone: false
})
export class AbsatzComponent implements OnInit, AfterViewInit {

  @Input()
  public uiArtefakt: AbsatzControl;

  public uiAusrichtung: UIAusrichtung;
  public textAusrichtung: TextAusrichtung = TextAusrichtung.TEXTAUSRICHTUNG_LINKSBUENDIG;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = false;
  public expansionPanel: boolean = false;
  public expansionPanelOpenState: boolean = false;

  constructor(private _shellConfigService: ShellConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  ngOnInit(): void {
    this.expansionPanel = (this.uiArtefakt.AbsatzComponent === 'Erweiterungspanel');
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
  }

  public trackByArtefakt(item: UIArtefakt) {
    return item.Identifikator;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

}
